const messages = {
  title: "Kauppa",
  description: "Tervetuloa premium-kauppaan. Täällä voit lunastaa Bridgestone Plus -pisteesi <br/> palkintoja eri luokista. Tuotevalikoimaa <br/> päivitetään säännöllisesti. Toivotamme sinulle paljon hauskaa selaamista.",
  sort: {
    asc: "Järjestä: Alin hinta",
    desc: "Järjestä: Korkein hinta",
  },
  productSearchBox: {
    from: "pisteet alkaen",
    to: "pisteet asti",
  },
  noProducts: "Hakuehdot eivät tuottaneet tuloksia",
  quantity: "Määrä",
  search: "Hae",
  perPage: "Kohteita per sivu",
  timeUnavailable: "Ei tällä hetkellä saatavilla",
  product: "Tuote",
  cart: {
    pointsPerUnit: "Pisteet per yksikkö",
    pointsSum: "Pisteiden summa",
  },
  action: "Toiminto",
  pointsTotal: "Yhteensä",
  cartRemainPoints: "Jäljellä olevat pisteet korissa",
  shoppingCart: "Ostoskori",
  emptyCart: "Ostoskori on tyhjä.",
  attributes: "Attribuutit",
  selectAddressP: "Valitse toimitusosoite",
  orderDelivery: "Toimitusosoite",
  selectedProducts: "Valitut tuotteet",
  orderSummary: "Tilauksen yhteenveto",
  contactPerson: "Yhteyshenkilö",
  selectedAddress: "Valittu osoite",
  order: {
    success: "Kiitos! Tilauksesi onnistui. Saat tilausvahvistuksen postilaatikkoosi muutaman minuutin kuluttua.",
    description: "Täältä löydät yleiskatsauksen palkintokaupan tilauksistasi.",
    info: "Täältä löydät yleiskatsauksen palkintokaupan tilauksistasi.",
    date: "Tilauspäivä",
    number: "Tilausnro",
    status: {
      created: "Luotu",
      confirm_order: "Vahvista tilaus",
      ready_for_shipment: "Valmis lähetettäväksi",
      rejected: "Hylätty",
      processed: "Käsitelty",
      shipped: "Lähetetty",
      returned: "Palautettu",
      finished: "Valmis",
    },
    anyOrder: "Ei tilauksia",
    products: "Tuotteet",
    quantity_short: "kpl",
    itemRemoved: "ei voida toimittaa",
  },
  orders: "Tilaukset",
  notEnoughPoints: "Pisteitä ei ole riittävästi saatavilla.",
  statusText: "Tila",
  outOfStock: "Ei tällä hetkellä varastossa",
  productUnavailable: "Tämä tuote ei ole enää saatavilla.",
  deletedProductsTitle: "Tuotteet eivät ole enää saatavilla",
  deletedProductsMessage: "Seuraavat tuotteet eivät ole enää saatavilla. Poista ne ostoskorista jatkaaksesi.",
  removeSelected: "Poista valitut",
  clearCart: "Tyhjennä ostoskori",
  removeSelectedConfirm: "Poistetaanko valitut tuotteet ostoskorista?",
  clearCartConfirm: "Poistetaanko kaikki tuotteet ostoskorista?",
  incompleteAddress: {
    firstName: "Lisää etunimi toimitusosoitteeseen",
    lastName: "Lisää sukunimi toimitusosoitteeseen",
    company: "Lisää yrityksen nimi toimitusosoitteeseen",
    street: "Lisää katu ja talonnumero toimitusosoitteeseen",
    postalCode: "Lisää postinumero toimitusosoitteeseen",
    city: "Lisää kaupunki toimitusosoitteeseen",
    country: "Lisää maa toimitusosoitteeseen",
    phone: "Lisää puhelinnumero toimitusosoitteeseen",
  },
  placeOrder: "Sitova tilaus",
  toOrderDelivery: "Jatka toimitusosoitteeseen",
  toOrderSummary: "Tilauksen yhteenvetoon",
  productImg: "Tuotekuva",
  selectAddressBtn: "Valitse osoite",
  perPgae: "Kohteita per sivu",
  categories: {
    advertising: {
      title: "Mainosmateriaalit",
      desc: "Osallistu suoraan täällä alustalla ja varmista <br/> 40 ylimääräistä pistettä palkintoklubiin.",
    },
    rewards: {
      title: "Eksklusiiviset palkinnot",
      desc: "Tutustu bonustarjontaan koulutuskeskuksessamme tai omalla paikallasi.",
    },
    tools: {
      title: "Korjaamotyökalut",
      desc: "Käytä pisteitäsi kolmannen osapuolen koulutuksiin <br/> ja vähennä kustannuksiasi.",
    },
    trainings: {
      title: "Koulutus ja kurssit",
      desc: "Tutustu bonustarjontaan koulutuskeskuksessamme tai omalla paikallasi.",
    },
    salesroom: {
      title: "Myyntitila",
      desc: "Sisusta myyntitila ja tarjoa asiakkaille miellyttävä oleskelu.",
    },
    hunter: {
      title: "Hunter",
      desc: "Vaihda pisteitä houkuttelevaan Hunter-korjaamovarustukseen.",
    },
  },
  bestSold: "Myydyimmät",
  seasonal: "Kausittainen",
  affordable: "Melkein valmis",
  forPoints: "{points} pisteellä",
  reachedPoints: "Vaaditut pisteet saavutettu",
  remainingPoints: "{points} pistettä jäljellä",
  favoriteProducts: {
    description: "Täältä löydät tallentamasi tuotteet.",
  },
  categoryPageDescriptionFallback: "Materiaalia korjaamolle tai muita laadukkaita tuotteita Bridgestone-logolla yrityksellesi",
  variant: "Valittavat variantit",
};
export default {
  messages,
};
